var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading"},[(_vm.loaded)?[_c('span',{staticClass:"text"},[_vm._v("已经到底了~")])]:(_vm.loading)?[_c('mt-spinner',{attrs:{"type":"fading-circle"}}),_c('span',{staticClass:"text"},[_vm._v("加载中...")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }